import React from "react";
import Hero from "../components/home/Hero";
import LoanProgramsSection from "../components/home/LoanProgramsSection";
import ProcessSection from "../components/home/ProcessSection";
import PropertyTypesSection from "../components/home/PropertyTypesSection";
import AboutSection from "../components/home/AboutSection";
import TestimonialsSection from "../components/home/TestimonialsSection";
import BlogSection from "../components/home/BlogSection";
import ToolsSection from "../components/home/ToolsSection";
import CTASection from "../components/home/CTASection";

export default function Home() {
  return (
    <main>
      <Hero />
      <LoanProgramsSection />
      <ProcessSection />
      <AboutSection />
      <PropertyTypesSection />
      <TestimonialsSection />
      <ToolsSection />
      <BlogSection />
      <CTASection />
    </main>
  );
}
